import { useContext } from "react";
import { SessionFlowContext } from "./../SessionFlowContext";

export function useSessionFlow() {
    return useContext(SessionFlowContext) || {};
}
